import { configureStore, isPlain } from '@reduxjs/toolkit';
import { brandsApi } from 'features/admin/brands/store/brandsApiSlice';
import { adminStudyEditorFullExamplesApi } from 'features/admin/protocol-editor/store/adminStudyEditorFullExamplesApiSlice';
import { activityTasksApi } from 'features/participations/schedule/store/activityTasksApiSlice';
import { participationDocumentApi } from 'features/participations/store/participationDocumentApiSlice';
import { activityTaskDocumentApi } from 'features/questionnaires/store/activityTaskDocumentApiSlice';
import { questionnaireAssetApi } from 'features/questionnaires/store/questionnaireAssetApiSlice';
import { adminProtocolEditorLocalStorageMiddleware } from './localStorageMiddleware';
import { rootReducer } from './rootReducer';
import type { Action, ThunkAction } from '@reduxjs/toolkit';

export const store = configureStore({
  reducer: rootReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: {
        // PROSE opaque state (contextData.internalState.data) is a Uint8Array.
        isSerializable: (value: unknown) =>
          isPlain(value) || ArrayBuffer.isView(value),
      },
    }).concat(
      activityTasksApi.middleware,
      activityTaskDocumentApi.middleware,
      questionnaireAssetApi.middleware,
      participationDocumentApi.middleware,
      adminStudyEditorFullExamplesApi.middleware,
      brandsApi.middleware,
      adminProtocolEditorLocalStorageMiddleware
    ),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action
>;
export type AppPromiseThunk<T = void, ReturnType = Promise<T>> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action
>;
